// Client wrappers for the AI helper Pages Functions.

import { apiJson } from "./apiFetch";
import type { Goals } from "./goals";

export interface DaySummary {
  date: string;
  calories: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
  meal_count: number;
}

export async function fetchWeeklyInsight(days: DaySummary[], goals: Goals): Promise<string> {
  const data = await apiJson<{ text?: string }>("/api/insight", {
    method: "POST",
    body: JSON.stringify({ days, goals })
  });
  return data.text ?? "";
}

export interface Suggestion {
  name: string;
  portion: string;
  calories: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
  fiber_g?: number;
  reason: string;
}

export async function fetchSuggestions(input: {
  remaining: { calories: number; protein_g: number; carbs_g: number; fat_g: number };
  meal_type: string;
}): Promise<Suggestion[]> {
  const data = await apiJson<{ suggestions?: Suggestion[] }>("/api/suggest", {
    method: "POST",
    body: JSON.stringify(input)
  });
  return data.suggestions ?? [];
}

// ---------------------------------------------------------------------------
// Recipe AI
// ---------------------------------------------------------------------------

import type { MealEstimate } from "./types";

export interface RecipeEstimate {
  name: string;
  servings: number;
  per_serving: MealEstimate;
}

/**
 * Parse a recipe (pasted text or URL) into a per-serving estimate.
 * The user can optionally override the servings detection.
 */
export async function fetchRecipeEstimate(
  text: string,
  servings?: number
): Promise<RecipeEstimate> {
  const data = await apiJson<RecipeEstimate>("/api/recipe", {
    method: "POST",
    body: JSON.stringify({ text, servings })
  });
  return data;
}
